import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import { Modal, useModal } from '@frontendmentorio/design-system-v2';

import GitHubAuthButton from 'features/shared/GitHubAuthButton';

export const AuthModal = ({ modal, redirectPath }) => {
  return (
    <Modal className="items-center text-center" modal={modal}>
      <Modal.Heading>Oops! 😬</Modal.Heading>
      <p>You need to be logged in before you can do that.</p>

      <GitHubAuthButton redirectPath={redirectPath} />
    </Modal>
  );
};

const withAuth = (Component) => {
  const ComponentWithAuth = ({ onClick, ...props }) => {
    const isLoggedIn = useSelector(selectCurrentUser);
    const modal = useModal();

    if (isLoggedIn) return <Component onClick={onClick} {...props} />;

    return (
      <>
        <Component {...props} onClick={modal.open} />
        <AuthModal modal={modal} redirectPath={props.redirectPath} />
      </>
    );
  };

  return ComponentWithAuth;
};

export default withAuth;
